// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // base_url: "https://dev.api.sinapsis.holadoc.tk/v1",
  // socket_url: "https://dev.api.sinapsis.holadoc.com/v1",

  // base_url: "https://qa.api.sinapsis.holadoc.tk/v1",
  // socket_url: "https://qa.api.sinapsis.holadoc.tk",

  // these two were on
  // base_url: "https://api.sinapsishealth.com/v1",
  // socket_url: "https://api.sinapsishealth.com",

  // base_url: "https://demo.api.sinapsis.holadoc.tk/v1",
  // socket_url: "https://demo.api.sinapsis.holadoc.tk",
  //base_url: "https://qa.api.poweredby.holadoc.tk/v1",
  base_url: "https://dev.api.framework.holadoc.com",
  socket_url: "https://dev.api.framework.holadoc.com",

  // base_url: "https://dev.api.poweredby.holadoc.tk/v1",
  // socket_url: "https://dev.api.poweredby.holadoc.tk",

  defaultLanguage: "es-ES",
  supportedLanguages: ["en-US", "es-ES"],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
